import { TimeLocales } from '@app/hooks/contexts/timeController/timeControllerTypes'

export const timeLocales: TimeLocales = {
	us: {
		df: 'MMM DD, YYYY',
		df1: 'DD MMM',
		df2: 'ddd',
		df3: 'MMM',
		df4: 'MMMM YYYY',
		df5: 'D',
		df6: 'dddd, MMM D, YYYY',
		df7: 'd',
		df8: 'ddd, D MMM',
		df9: 'D.MM ',
		tf: 'hh:mm A',
		tdf1: 'MMM DD YYYY, hh:mm A',
		tdf2: 'MMM DD, hh:mm A',
		tdf3: 'hh:mm A MMM DD, YYYY',
	},

	eu: {
		df: 'DD/MM/YYYY',
		df1: 'DD MMM',
		df2: 'ddd',
		df3: 'MMM',
		df4: 'MMMM YYYY',
		df5: 'D',
		df6: 'dddd, DD/MM/YYYY',
		df7: 'd',
		df8: 'ddd, D MMM',
		df9: 'D.MM ',
		tf: 'HH:mm',
		tdf1: 'DD/MM/YY, HH:mm',
		tdf2: 'DD/MM/YY, HH:mm',
		tdf3: 'DD/MM/YY, HH:mm',
	},
}
